var map = {
	"./account-icon.svg": "6f47",
	"./ax-icon.svg": "60cc",
	"./close-icon.svg": "d144",
	"./closebtn-icon.svg": "a9f7",
	"./config-account-icon.svg": "2bf9",
	"./document-icon.svg": "6647",
	"./download-icon.svg": "8d12",
	"./folios-icon.svg": "6ca4",
	"./help-icon.svg": "da59",
	"./home-icon.svg": "3177",
	"./metrics-icon.svg": "7819",
	"./open-icon.svg": "eb57",
	"./pos-icon.svg": "e602",
	"./purchase-icon.svg": "8a00",
	"./report-icon.svg": "2957"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5035";